export default __webpack_public_path__ + "static/media/expirationDatePic.12c19e9e.png";